import { FC } from "react";
import styles from './../../map.module.scss'
import { store } from 'stores/Store';
import { ReactComponent as IdentificationIcon } from 'assets/blueIdentificationCard.svg';
import { ReactComponent as NavigationArrowIcon } from 'assets/navigationArrowRight.svg';
import { ReactComponent as AddRouteIcon } from 'assets/addRoute.svg';


interface Props {
  onSlideMenuOpen: () => void;
  onRouteMenuOpen: () => void;
  onAddToRoute: (p: any) => void;
  practitioner?: any;
}

const MiniMenu: FC<Props> = ({ onSlideMenuOpen, onRouteMenuOpen, onAddToRoute, practitioner }) => {
  if (!practitioner) return <></>;

  const defaultAddressInfo = practitioner?.addresses
      ?.find((a: any) => a.id === practitioner?.default_address);

  const isLocation = !!(typeof practitioner?.id === "string");

  return (
    <div className={styles.focusedPractitionerContainer}>
      <div className={styles.focusedPractitioner}>
        <div >
          <div className={styles.practitionerName}>{practitioner?.name || practitioner?.primary_name}</div>
          <div className={styles.subInfo}>
            {defaultAddressInfo?.address1 ? (
              <>
                {defaultAddressInfo?.address1}, {defaultAddressInfo?.address2} <br />
                {defaultAddressInfo?.city}, {defaultAddressInfo?.state} {defaultAddressInfo?.zipcode}
              </>
            ) : (
              <>
                {defaultAddressInfo?.address}
              </>
            )}
            {isLocation && (
              <>
                {practitioner?.formatted_address}
              </>
            )}
            
          </div>
          <div className={styles.subInfo}>{practitioner?.specialty}</div>
        </div>
        <div className={styles.iconsContainer}>
          <div className={styles.blueIdentificationCard} onClick={() => {
            store.setCurrentPractitioner(practitioner);
            onSlideMenuOpen()
          }}>
            <IdentificationIcon />
          </div>
          <div onClick={() => onRouteMenuOpen()}>
            <NavigationArrowIcon stroke={'#4F7D9C'} width="24px" height="24px" />
          </div>
          {!isLocation && (
            <div onClick={() => onAddToRoute(practitioner)} className={styles.addRouteIcon}>
              <AddRouteIcon />
            </div>
          )}
          
        </div>
      </div>

    </div>
  );
};

export default MiniMenu;